import React, { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";

export default function FailedPaymentModal({
  cancelModal,
  id,
}) {
  const [failedPayment, setFailedPayment] = useState([]);


  const [isLoading, setIsLoading] = useState(true);
  const { user } = useAuthContext();

  useEffect(() => {
    setIsLoading(true);

    const fetchData = async () => {
      try {
        const failedPaymentResponse = await axios.get(
          `${ApiConnectionString}/api/FailedPayment/${id}`,
          {
            headers: { Authorization: `bearer ${user.token}` },
          }
        );
        if (failedPaymentResponse.status === 200) {
          setFailedPayment(failedPaymentResponse.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user]);
  const handleClick = () => {
    window.location.href = failedPayment.invoiceUrl;
  };

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="blueBanner">
            <p className="fw-bold m-2 p-2 fontSize20"> Failed payment</p>
          </div>

          <button
            type="button"
            className="close-button"
            onClick={cancelModal}
            aria-label="Close"
          >
            &times;
          </button>
          <div className="d-flex">
            <p className="red-text fw-bold mx-2"> Scope: </p>{" "}
            <p>
              {new Date(failedPayment.periodStart).toLocaleDateString()} -{" "}
              {new Date(failedPayment.periodEnd).toLocaleDateString()}
              {/* {failedPayment.periodStart.toLocaleDateString()}
              {failedPayment.periodEnd.toLocaleDateString()}{" "} */}
            </p>
          </div>
          <div className="d-flex">
            <p className="red-text fw-bold mx-2">Club:</p>{" "}
            <p>{failedPayment.viewClubs.name} </p>
          </div>
          <div className="d-flex">
            <p className="red-text fw-bold mx-2">Package</p>{" "}
            <p>
              {" "}
              {failedPayment &&
                (failedPayment.premium ? (
                  <p>Premium Membotic Club</p>
                ) : (
                  <p>{failedPayment.viewProduct.name}</p>
                ))}
            </p>
          </div>

          {!failedPayment.resolved &&
            failedPayment.subscriptionStatus != "canceled" &&
            !failedPayment.premium && (
              <p>
                A payment for your subscription from the club{" "}
                {failedPayment.viewClubs.name} for the package{" "}
                {failedPayment.viewProduct.name} is due. This payment covers the
                use of the club from{" "}
                {new Date(failedPayment.periodStart).toLocaleDateString()} to{" "}
                {new Date(failedPayment.periodEnd).toLocaleDateString()}. You
                can make the payment and resolve this issue by pressing
                "Resolve" below.
              </p>
            )}

          {!failedPayment.resolved &&
            failedPayment.subscriptionStatus !== "canceled" &&
            failedPayment.premium && (
              <p>
                A payment for your subscription to Membotic Premium Club is
                overdue. To retain all the perks of being a premium club, please
                amend this payment by pressing the "Resolve" button below.
              </p>
            )}

          {failedPayment.subscriptionStatus == "canceled" && (
            <p className="text-danger">
              Your subscription has been canceled. Please note that making a
              resovle payment will not renew your membership. To renew your
              membership, please re-subscribe through the club page.
            </p>
          )}
          {!failedPayment.resolved ? (
            <button className="saveChanges-button mx-3" onClick={handleClick}>
              Resolve
            </button>
          ) : (
            <div>
              <p className="text-success">This has been resolved</p>{" "}
              <button className="saveChanges-button mx-3" onClick={handleClick}>
                View Resoltuion
              </button>
            </div>
          )}
          <div className="send-modal-footer">
            <button
              onClick={cancelModal}
              className="pointer cancelButton fw-bold mx-2 px-3"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}
